import React from 'react'

type NavHeightContextType = {
    navHeight: number
    setNavHeight: (height: number) => void
}

const NavHeightContext = React.createContext<NavHeightContextType | undefined>(undefined)

export default NavHeightContext